export class Breadcrumb {
  public constructor(public routeUrl: string = '', public routeName: string = '') {}
}
